import React, {useState} from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import {selectSubscriptionText} from '../selectSubscriptionText';
import './styles.css';
import {FAQ, subscriptionPlans} from '../subscriptionPlans';
import FeaturesTable from '../components/FeaturesTable';
import PlansSwitch from '../components/PlansSwitch';
import {SUBSCRIPTION_TRIAL} from '../../config';
import SubscriptionDetails from '../components/SubscriptionDetails';
// import PlansCalculator from '../components/PlansCalculator';
import FaqCard from '../components/FaqCard';
import SubscriptionHeader from '../components/SubcsriptionHeader';

interface Props {
  onSelect: (tier?: number) => void;
  isLoggedIn: boolean;
  logOut: () => void;
}

const SelectSubscriptionUI = React.memo(
  ({onSelect, isLoggedIn, logOut}: Props) => {
    const [planToShow, setPlanToShow] = useState(SUBSCRIPTION_TRIAL);

    const getCurrentPlan = () => {
      const result = subscriptionPlans.find(x => x.id === planToShow);
      if (result) {
        return result;
      } else {
        return subscriptionPlans.find(x => x.id === undefined);
      }
    };

    const handleTableSelect = (planId?: number) => {
      if (planId == null) return;
      setPlanToShow(planId);
      // opcional: scrollear al switch o a los precios
      document
        .querySelector('.PlansSwitchContainer')
        ?.scrollIntoView({behavior: 'smooth', block: 'start'});
    };

    return (
      <>
        <SubscriptionHeader isLoggedIn={isLoggedIn} logOut={logOut} />

        <div className="SelectSubscriptionContainer">
          <h2 className="SelectTitle">{selectSubscriptionText.selectTitle}</h2>
          <div className="SwitchWrapper">
            <PlansSwitch
              selectedPlan={planToShow}
              setSelectedPlan={setPlanToShow}
            />
          </div>
          <SubscriptionDetails plan={getCurrentPlan()} onSelect={onSelect} />
          {/* <PlansCalculator /> */}
          <Container>
            <Row>
              <Col xs={12}>
                <FeaturesTable onSelect={handleTableSelect} />
                <p className="Footnote">
                  {selectSubscriptionText.tableFootnote}
                </p>
              </Col>
            </Row>
          </Container>
          <Container>
            <Row>
              <Col lg={{span: 9, offset: 1}} xs={12}>
                <h2 className="FAQTitle">{selectSubscriptionText.faq}</h2>
                <div>
                  {FAQ.map(faq => (
                    <FaqCard {...faq} key={faq.question} />
                  ))}
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </>
    );
  },
);

export default SelectSubscriptionUI;
